export interface TranslatedAudioTimingProfile {
  detectIntervalSec: number;
  leadSec: number;
  outputLatencySec: number;
  backfillSec: number;
}

export const DEFAULT_TRANSLATED_AUDIO_TIMING: TranslatedAudioTimingProfile = {
  detectIntervalSec: 0.02,
  leadSec: 0.12,
  outputLatencySec: 0.12,
  backfillSec: 0.06,
};

export const createTranslatedAudioTiming = (
  overrides?: Partial<TranslatedAudioTimingProfile>
): TranslatedAudioTimingProfile => {
  return {
    ...DEFAULT_TRANSLATED_AUDIO_TIMING,
    ...overrides,
  };
};

export const computeSubtitleMatchTime = (videoTime: number, profile: TranslatedAudioTimingProfile): number => {
  return videoTime + profile.leadSec;
};

export const computeAudioSeekOffset = (
  videoTime: number,
  subtitleStartTime: number,
  profile: TranslatedAudioTimingProfile
): number => {
  const scheduledPlaybackTime = videoTime + profile.outputLatencySec;
  return scheduledPlaybackTime - subtitleStartTime - profile.backfillSec;
};
